<script lang="ts">
  import {
    getUrlForEntity as getUrlForGameraEntity,
    type GameraEntity,
  } from '@statmuse/core/gamera'
  import {
    getUrlForEntity as getUrlForKanedamaEntity,
    type KanedamaEntity,
  } from '@statmuse/core/kanedama'

  export let entity: GameraEntity | KanedamaEntity | undefined

  const isKanedamaEntity = (
    x: GameraEntity | KanedamaEntity,
  ): x is KanedamaEntity => x.type === 'assetProfile' || x.type === 'btcBlock'

  $: title = entity?.display ?? ''
  $: url =
    entity && entity.id
      ? isKanedamaEntity(entity)
        ? getUrlForKanedamaEntity(entity)
        : getUrlForGameraEntity(entity)
      : ''
</script>

{#if url}
  <a href={url} {title} {...$$restProps}>
    <slot />
  </a>
{:else}
  <span {...$$restProps}>
    <slot />
  </span>
{/if}
